var _path, _path2, _path3, _path4, _path5, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _path6, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDashboardfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.61,4.5H39.39a34.08,34.08,0,0,0-34,34v241a34.08,34.08,0,0,0,34,34H361.61a34.08,34.08,0,0,0,34-34v-241A34.08,34.08,0,0,0,361.61,4.5Zm7.89,239.72a6.28,6.28,0,0,1-6.28,6.28H37.78a6.28,6.28,0,0,1-6.28-6.28V36.78a6.28,6.28,0,0,1,6.28-6.28H363.22a6.28,6.28,0,0,1,6.28,6.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5,112.78V55.65A59,59,0,0,0,70,152.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5,110.5h54.85A59,59,0,0,0,119.5,55.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.09,118.5,75.51,157.87a59,59,0,0,0,98.84-39.37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5,133.5a4,4,0,0,1-2.8-6.85l53.93-53a8.42,8.42,0,0,1,11.74,0l47.8,46.91a.41.41,0,0,0,.27.11.34.34,0,0,0,.26-.12l30.88-31.64a4,4,0,0,1,5.72,5.58l-30.87,31.65a8.38,8.38,0,0,1-11.87.13L253.77,79.37a.37.37,0,0,0-.53,0l-53.94,53A4,4,0,0,1,196.5,133.5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "346.35 133.53 338.35 133.35 339.3 93.91 299.9 95.84 299.52 87.84 347.5 85.5 346.35 133.53"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 192.5,
    width: 111,
    height: 11,
    rx: 5.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 218.5,
    width: 69,
    height: 11,
    rx: 5.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 194.87,
    y: 164.5,
    width: 34.26,
    height: 63,
    rx: 4.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 249.87,
    y: 127.5,
    width: 34.26,
    height: 97,
    rx: 5.46
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 305.87,
    y: 185.5,
    width: 34.26,
    height: 40,
    rx: 3.51
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 277.5,
    r: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M312.5,377.5a18.06,18.06,0,0,1-18,18h-189a18,18,0,0,1,0-36h189A18.05,18.05,0,0,1,312.5,377.5Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "267 359 133 359 149.98 313.5 246.78 313.5 267 359"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDashboardfill);
export default __webpack_public_path__ + "static/media/Icons_Dashboard  fill.58235a4d04e3b6cb4dfec8ce62b0d47d.svg";
export { ForwardRef as ReactComponent };